import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { Footer } from '@teko/ecommerce';
import { ScrollTopArrow } from '@teko/ui';
import { styled } from '@teko/ds-desktop';
import { Messenger, TopBanners } from '@teko/ecommerce';
import { getRightMenu, getFooterData } from './Layout.data';
import { useRouter } from 'next/router';
import { MobioContextProvider, useHelper } from 'contexts';
import { useTenantConfig } from 'hooks';
import { PhongVuProductHelper } from './helpers/product';
import { MenuItem } from '@teko/discovery';
import { NavigationBar } from 'tenants/_template/desktop/_module/components/NavigationBar';
import { Topbar } from '@teko/teko-ecommerce';

const TopBannerWrapper = styled.div(
  ({ visible }: { visible: boolean }) => `
  height: 56px;
  display: ${visible ? 'block' : 'none'};
`,
);

export interface LayoutProps {
  children: React.ReactNode;
  banners?: any;
  liteLogo?: boolean;
  menuItems?: MenuItem[];
}

const leftMenu: Array<ReactNode> = [];
const invisbleTopBannerInPaths = ['/cart', '/checkout'];

export const Layout: React.FunctionComponent<LayoutProps> = ({
  children,
  banners,
  liteLogo,
  menuItems,
}: LayoutProps) => {
  const [shouldHideTopBanners, setShouldHideTopBanners] = useState(false);
  const { contactLink, isDisplayMessenger, baseDomain, freeShippingThreshold } =
    useTenantConfig();
  const { setProductHelper } = useHelper();

  const router = useRouter();
  const topBannersVisible = useMemo(() => {
    if (shouldHideTopBanners || !banners || (banners && banners.length === 0)) {
      return false;
    }
    for (const path of invisbleTopBannerInPaths) {
      if (router.pathname.includes(path)) {
        return false;
      }
    }
    return true;
  }, [router.pathname, banners, shouldHideTopBanners]);

  useEffect(() => {
    const phongvuProductHelper = new PhongVuProductHelper(
      freeShippingThreshold,
    );
    setProductHelper(phongvuProductHelper);
  }, []);

  const rightMenu = getRightMenu();
  const footerData = getFooterData();

  return (
    <MobioContextProvider>
      <TopBannerWrapper visible={topBannersVisible}>
        {topBannersVisible && (
          <TopBanners
            banners={banners}
            onClose={(): void => setShouldHideTopBanners(true)}
          />
        )}
      </TopBannerWrapper>
      <Topbar leftMenu={leftMenu} rightMenu={rightMenu} />
      <NavigationBar
        liteLogo={liteLogo}
        menuItems={menuItems}
        displayConfig={{
          order: true,
          promotion: true,
          notification: true,
        }}
      />
      <div>{children}</div>
      <Footer footer={footerData} baseUrl={baseDomain} />
      <ScrollTopArrow />
      {contactLink && isDisplayMessenger && <Messenger url={contactLink} />}
    </MobioContextProvider>
  );
};
